import React, { createContext, useContext } from 'react';
import { logErrorToServerside, logInfoToServerSide } from './logging';

const LoggerContext = createContext<LoggerContextType | null>(null);

export function useLogger() {
    const context = useContext(LoggerContext);
    if (!context) {
        throw new Error('useLogger hook is only useable in tree under LoggerContextProvider element.');
    }
    return context;
}

type LoggerContextProviderProps = {
    applicationId: string;
    applicantId?: string | null;
    backend: Backend;
};

type LoggerContextType = {
    error: (message: string, error?: object | Error | unknown) => Promise<void>;
    info: (message: string) => Promise<void>;
};

export function LoggerContextProvider({ applicationId, applicantId, backend, children }: React.PropsWithChildren<LoggerContextProviderProps>) {
    const value: LoggerContextType = {
        error: async function (message: string, error?: unknown): Promise<void> {
            logErrorToServerside(message, applicationId, applicantId, error, backend);
        },
        info: async function (message: string): Promise<void> {
            logInfoToServerSide(message, applicationId, applicantId, backend);
        },
    };
    return <LoggerContext.Provider value={value}>{children}</LoggerContext.Provider>;
}
